export const RECEIVED_ALL = 'RECEIVED_ALL';
export const INIT_RECEIVED_ALL = 'INIT_RECEIVED_ALL';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
